import { Location } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TermsAndConditionsViewModelResultResponse } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreRegistrationService } from '@services/cleanfill-core/store-registration/store-registration.service';
import { AuthService } from '@services/core/auth.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class TermsComponent implements OnInit {
  uniqueId: string;
  form: FormGroup;
  details: TermsAndConditionsViewModelResultResponse;
  constructor(
    private registrationStore: StoreRegistrationService,
    private authService: AuthService,
    public router: Router,
    private _location: Location,
    private fb: FormBuilder
  ) {}

  async ngOnInit() {
    this.uniqueId = this.authService.activeUser.uniqueId;
    this.form = this.fb.group({
      acceptTerms: [false]
    });

    this.details = await this.registrationStore.getTermsAndConditions();
  }

  async accept() {
    await this.registrationStore.userAcceptTerm(this.uniqueId);
    this.authService.patchActiveUserAcceptTerm();
    if (this.authService.activeUser.legalEntityName) {
      if (this.authService.activeUser.inviteUniqueId) {
        this.router.navigateByUrl(`/register/accept-invite?${this.authService.activeUser.inviteUniqueId}`);
      } else {
        this._location.back();
      }
    } else {
      this.router.navigate(['register', 'choose', 'company', 'new']);
    }
  }
}
